import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Modal, Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getactionMessages, getInvoicingMessages, getModalMessages } from '../../constants/messages';
import { roundN } from '../../utilities/util';

let ModalMessages = getModalMessages(),
	ActionMessages = getactionMessages(),
	invoicingMessages = getInvoicingMessages();

const messages = {
	...ActionMessages,
	...ModalMessages,
	...invoicingMessages,
};

const AnnualInvoicesCheckModal = ({ handleCancel, showModal, annualInvoices }) => {
	const intl = useIntl();
	const history = useHistory();

	const onInvoiceNumberClick = (e, invoiceId) => {
		e.preventDefault();
		history.push(`/invoices/${invoiceId}`);
	};

	const columns = [
		{
			title: intl.formatMessage({ ...messages.Client }),
			dataIndex: 'clientName',
			key: 'clientName',
			render: (name, invoice) => {
				return invoice.client.name;
			},
		},
		{
			title: intl.formatMessage({ ...messages.InvoiceNumber }),
			dataIndex: 'documentNumber',
			key: 'documentNumber',
			render: (documentNumber, invoice) => {
				return (
					<a
						className="editable-add-btn"
						href={`/invoices/${invoice.id}`}
						onClick={(e) => onInvoiceNumberClick(e, invoice.id)}
					>
						{documentNumber}
					</a>
				);
			},
		},
		{
			title: intl.formatMessage({ ...messages.Date }),
			dataIndex: 'createdAt',
			key: 'createdAt',
			render: (date) => {
				return moment(date).locale('es').format('L');
			},
		},
		{
			title: intl.formatMessage({ ...messages.Total }),
			dataIndex: 'total',
			key: 'total',
			className: 'column-money',
			render: (total, invoice) => {
				return `L ${roundN(total * invoice.exchangeRate, 2)}`;
			},
		},
	];

	return (
		<Modal
			title={intl.formatMessage({ ...messages.annualInvoices })}
			open={showModal}
			onCancel={handleCancel}
			footer={null}
			destroyOnClose
			width={800}
		>
			<Table dataSource={annualInvoices} columns={columns} pagination={false} size="small" />
		</Modal>
	);
};

AnnualInvoicesCheckModal.propTypes = {
	handleCancel: PropTypes.func.isRequired,
	showModal: PropTypes.bool.isRequired,
	annualInvoices: PropTypes.array.isRequired,
};

export default AnnualInvoicesCheckModal;
